import axios from "axios";
import Papa from "papaparse"; // Import PapaParse

// Base URL for API requests
const BASE_URL = "https://api.ipaisa.co.in/myapp/auth";

// Set up an axios instance
// Set up an axios instance
const api = axios.create({
  baseURL: BASE_URL,
});

// Add a request interceptor to dynamically set the Authorization header
api.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("jwtToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Fetch debit data
export const fetchDebitData = async (query, start, end, page, size) => {
  try {
    const response = await api.get("/wtransReportDebt", {
      params: {
        seaechBy: query,
        startDate: start, // Example date (YYYY-MM-DD)
        endDate: end,
        currentPage: page, // Page number (starts from 0)
        pageSize: size, // Number of records per page
      },
    });
    // console.log(response.data);
    // if()
    return response.data;
  } catch (error) {
    console.error("Error fetching debit data:", error);
    throw error;
  }
};

// Fetch credit data
export const fetchCreditData = async (query, start, end, page, size) => {
  try {
    const response = await api.get("/wtransReportCred", {
      params: {
        seaechBy: query,
        startDate: start, // Example date (YYYY-MM-DD)
        endDate: end,
        currentPage: page, // Page number (starts from 0)
        pageSize: size, // Number of records per page
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching credit data:", error);
    throw error;
  }
};

// Search in wallet transactions
export const searchWalletTransaction = async (query) => {
  try {
    const response = await api.get(
      `/searchInWalletTransaction?searchBy=${query.toLowerCase()}`
    );
    return response.data.body?.data || [];
  } catch (error) {
    console.error("Error during search in wallet transaction:", error);
    throw error;
  }
};

// Download report as CSV
export const generateCSV = (data, type) => {
  const csvData = data.map((row, index) => ({
    "Sr. No.": index + 1,
    "Transaction ID": row.tranxid,
    "Sender Name": row.senderName,
    "Receiver Name": row.receiverName,
    Date: new Date(row.date).toLocaleString(),
    Amount: row.amount.toFixed(2),
    "Transaction Type": row.transactionType,
  }));

  // Generate and trigger download of CSV
  const csv = Papa.unparse(csvData);
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.setAttribute("download", `${type}_Transaction_Statement.csv`);
  a.style.visibility = "hidden";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};
